import { render } from "./contentindex.vue?vue&type=template&id=979bff12&scoped=true"
import script from "./contentindex.vue?vue&type=script&lang=js"
export * from "./contentindex.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-979bff12"]])

export default __exports__